module.exports = __webpack_public_path__ + "img/dotted.36381fb4.svg";